import apiClient from './apiClient.ts';

export interface LeaderboardEntry {
  rank: number;
  user_id: string;
  email: string;
  display_name: string | null;
  show_email: boolean;
  upload_count: number;
  is_current_user: boolean;
}

export interface LeaderboardResponse {
  entries: LeaderboardEntry[];
  current_user_rank: number | null;
  current_user_upload_count: number;
  uploads_behind_next: number | null;
  period: string;
}

export const getLeaderboard = async (period: 'monthly' | 'yearly' | 'overall' = 'monthly'): Promise<LeaderboardResponse> => {
  const response = await apiClient.get('/leaderboard', {
    params: { period }
  });
  // Response structure: { title, message, data: LeaderboardResponse }
  return response.data.data;
};

